import React from "react";
import { Flex, Text, FileUpload, FileObjectType } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import * as uploadStyles from "../styles_vanilla.css";

interface FileUploadSectionProps {
  fileUploadKey: number;
  onFileSelected: (files: FileObjectType[]) => void;
}

const FileUploadSection: React.FC<FileUploadSectionProps> = ({
  fileUploadKey,
  onFileSelected,
}) => {
  return (
    <Flex flexDirection="column" gap={Sizes.MD}>
      <Flex className={uploadStyles.uploadSectionHeader} alignItems="center" gap={Sizes.SM}>
        <Icon type="upload" size="small" color={Colors.Neutral900} />
        <Text variant="strong-lg" color={Colors.Neutral900}>
          Upload Files to Import
        </Text>
      </Flex>

      <FileUpload
        key={fileUploadKey}
        canAllowMultiple
        showFileList={false}
        onFileSelected={onFileSelected}
        acceptedFileTypes={[".csv", ".tsv", "text/csv", "text/tab-separated-values"]}
        isFullWidth={true}
      />
    </Flex>
  );
};

export default FileUploadSection;
